export type Theme = 'light' | 'dark';

// Pen ink tokens: [light, dark]
const INK: Record<string, [string, string]> = {
  'ink-charcoal': ['#2B2B33', '#ECEAE4'],
  'ink-coral':    ['#D9705A', '#F0A48F'],
  'ink-sage':     ['#6E9C8A', '#9CC4B4'],
  'ink-ocean':    ['#4A7A96', '#7FB0CC'],
  'ink-plum':     ['#7D5A82', '#B08CB5'],
  'ink-amber':    ['#C98A2D', '#E0AE58'],
  'ink-brick':    ['#A94F42', '#D07E70'],
  'ink-slate':    ['#5C6672', '#9AA6B4'],
};

// Highlighters: [light rgba, dark rgba]
const HIGHLIGHT: Record<string, [string, string]> = {
  'highlight-yellow': ['rgba(255,229,138,0.45)', 'rgba(212,185,78,0.40)'],
  'highlight-coral':  ['rgba(232,146,124,0.35)', 'rgba(240,164,143,0.32)'],
  'highlight-sage':   ['rgba(143,184,168,0.35)', 'rgba(156,196,180,0.32)'],
};

export const INK_TOKENS = Object.keys(INK);
export const HIGHLIGHT_TOKENS = Object.keys(HIGHLIGHT);

export function resolveInk(token: string, theme: Theme): string {
  const pair = INK[token] ?? HIGHLIGHT[token] ?? INK['ink-charcoal']!;
  return theme === 'dark' ? pair[1] : pair[0];
}

export function isHighlight(token: string): boolean {
  return token in HIGHLIGHT;
}

/** Page/canvas background fill (thumbnails, base layer). */
export function paperColor(theme: Theme): string {
  return theme === 'dark' ? '#1E1E22' : '#FDFBF7';
}
